import React from "react";

const Loader = ({ settingsLoader }) => {
  return (
    <div className="settings__loader_wrap">
      <div className="lds-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className="settings__loader_text">{settingsLoader}</div>
    </div>
  );
};

export default Loader;
